import moment from "moment";

export const DATE_RANGE_TYPE = {
    all: "all",
    today: "today",
    custom: "custom",
    last7days: "last7days",
    last14days: "last14days",
    last30days: "last30days",
    last3months: "last3months",
    last12months: "last12months",
};

const formatAs = (m) => m.format("yyyy-MM-DD");
const START_DATE = ""; // start date in range is an EMPTY string (back-end will handle the start date)

export const DATE_RANGE_MAPPER = {
    [DATE_RANGE_TYPE.all]: () => makeFilter(START_DATE, moment()),
    [DATE_RANGE_TYPE.today]: () => makeFilter(moment(), moment()),
    [DATE_RANGE_TYPE.custom]: ([from = new Date(), to = new Date()] = []) =>
        makeFilter(moment(from), moment(to)),
    [DATE_RANGE_TYPE.last7days]: () => makeFilter(moment().subtract(7, "d"), moment()),
    [DATE_RANGE_TYPE.last14days]: () => makeFilter(moment().subtract(14, "d"), moment()),
    [DATE_RANGE_TYPE.last30days]: () => makeFilter(moment().subtract(30, "d"), moment()),
    [DATE_RANGE_TYPE.last3months]: () => makeFilter(moment().subtract(3, "M"), moment()),
    [DATE_RANGE_TYPE.last12months]: () => makeFilter(moment().subtract(12, "M"), moment()),
};

/**
 * @param momentFrom {Moment | ''}
 * @param momentTo {Moment}
 *
 * @return {from: string, to: string, queryFor: string}
 * */
function makeFilter(momentFrom, momentTo) {
    const from = momentFrom ? formatAs(momentFrom) : "";
    const to = formatAs(momentTo);
    return {
        from,
        to,
        queryFor: [from, to].join(","),
    };
}
